import { defineTool } from '@/shell/tool';

/** Slides: Vibes' slide maker in a frame (Flutter's `slides` embed). */
export default defineTool({
  id: 'vibes-slides',
  title: 'Slides',
  summary: "Vibes' slide maker, in a frame.",
  section: 'schools',
  order: 20,
  icon: 'co_present',
  owner: '@Drabu',
  permission: 'vibes-slides:use',
  routes: () => import('./SlidesPage'),
});
